export default {
    Adimplencia: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "status-de-adimplencia"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Adimplencia.js
// module id = 57tL
// module chunks = 13